// extracted by mini-css-extract-plugin
module.exports = {"main-container":"_3DEk08lechO5Jl8B7F9_qx","title":"o7HfvPWSepuF9PpQfjPxu","icon-wrapper":"_3IfaH1aT5RXnGtCS4McTIL","icon":"_2gH6J4lTAA3kujuJdOl1fF"};